<script lang="ts">
  import { onMount } from 'svelte';

  import { _ } from 'svelte-i18n';
  import { AppState, SetNotification } from '../../../etc/stores';
  import { formatMoney } from '../../../etc/utils';
  import { replaceVariables } from '../../../i18n';
  import Analytics from '../../../services/analytics';
  import flagKeys from '../../../etc/flagKeys';

  let amount = '';

  $: {
    const money = $AppState.freeCoinsCampaign.coinsReward;
    if (!money || $AppState.freeCoinsCampaign.alreadyRedeemed) {
      setTimeout(() => {
        if ($AppState.website.category === 'remindWelcomeCoin') {
          SetNotification('', true);
        }
      });
    }

    amount = formatMoney($AppState.business.location, money);
  }

  const t = (text: string, values?: any) => {
    return replaceVariables($_(`messages.remind_welcome_coin.${text}`), values);
  };

  const onClick = () => {
    if ($AppState.freeCoinsCampaign.id) {
      SetNotification('welcomeCoinAvailable', true);
    }
  };

  onMount(() => {
    if ($AppState.featureFlags.includes(flagKeys.SEGMENT_CLOSE_WELCOME_COINS))
      Analytics.logEvent('close-coupon-trigger', 'free-coins-state');
  });
</script>

<p on:click={() => onClick()}>{@html t('message', { AMOUNT: amount })}</p>

<style lang="scss">
  @use './styles.scss' as *;
</style>
